import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { deleteDebtorAttachmentAsync, getAllAttachmentsByDebtorIdAsync } from '@application/features/debtors/debtorThunk';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { formatDMY, handleRolePermission } from '@infrastructure/helpers';
import AttachmentPreviewModal from '@ui/components/VnAttachmentPreviewModal';
import VnButton from '@ui/components/VnButton';
import VnConfirmationModel from '@ui/components/VnConfirmationModel';
import ModalPopup from '@ui/components/VnModal';
import { trashOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';
const AttachmentsTable = ({ formData, isAttachmentTabBold }) => {
    const { debtorAttachments } = useAppSelector((state) => state.debtors);
    const dispatch = useAppDispatch();
    const [isDeleteConformOpen, setIsDeleteConformOpen] = useState(false);
    const [selectedAttachmentId, setSelectedAttachmentId] = useState(0);
    const [isAttachmentPreviewOpen, setIsAttachmentPreviewOpen] = useState(false);
    const [attachmentSrc, setAttachmentSrc] = useState('');
    useEffect(() => {
        if (formData.id) {
            dispatch(getAllAttachmentsByDebtorIdAsync(formData.id))
                .unwrap()
                .then((res) => {
                if (isAttachmentTabBold && res.length > 0) {
                    isAttachmentTabBold(true);
                }
                else {
                    isAttachmentTabBold && isAttachmentTabBold(false);
                }
            });
        }
    }, [dispatch, formData.id]);
    const imageType = (fileExtension) => {
        if (fileExtension === 'png' || fileExtension === 'jpg' || fileExtension === 'jpeg') {
            return 'png-icon.png';
        }
        else if (fileExtension === 'pdf') {
            return 'pdf-icon.png';
        }
        else if (fileExtension === 'xlsx' || fileExtension === 'xls' || fileExtension === 'csv') {
            return 'csv-icon.png';
        }
        return 'png-icon.png';
    };
    const deleteDebtorAttachment = (attachmentId) => {
        setIsDeleteConformOpen(true);
        setSelectedAttachmentId(attachmentId);
    };
    function onCancelDeleteClicked() {
        setIsDeleteConformOpen(false);
    }
    function onDeleteClicked() {
        if (selectedAttachmentId > 0) {
            dispatch(deleteDebtorAttachmentAsync(selectedAttachmentId))
                .unwrap()
                .then((res) => {
                dispatch(getAllAttachmentsByDebtorIdAsync(formData.id))
                    .unwrap()
                    .then((res) => {
                    if (isAttachmentTabBold && res.length > 0) {
                        isAttachmentTabBold(true);
                    }
                    else {
                        isAttachmentTabBold && isAttachmentTabBold(false);
                    }
                });
                setIsDeleteConformOpen(false);
                setSelectedAttachmentId(0);
            });
        }
    }
    function onRowClick(attachmentId) {
        if (debtorAttachments) {
            const attachment = debtorAttachments.find((attachment) => attachment.id === attachmentId);
            if (attachment) {
                const fileExtension = attachment.fileName.substring(attachment.fileName.lastIndexOf('.') + 1).toLocaleLowerCase();
                if (fileExtension === 'jpeg' || fileExtension === 'jpg') {
                    setIsAttachmentPreviewOpen(true);
                    setAttachmentSrc('data:image/jpeg;base64,' + attachment.document);
                }
                else if (fileExtension === 'png') {
                    setIsAttachmentPreviewOpen(true);
                    setAttachmentSrc('data:image/png;base64,' + attachment.document);
                }
                else if (fileExtension === 'pdf') {
                    setIsAttachmentPreviewOpen(true);
                    setAttachmentSrc('data:application/pdf;base64,' + attachment.document);
                }
                else if (fileExtension === 'xlsx' || fileExtension === 'xls' || fileExtension === 'csv') {
                    const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${attachment.document}`;
                    const downloadLink = document.createElement('a');
                    const fileName = attachment.fileName;
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                }
                else {
                    const linkSource = `data:application/octet-stream;base64,${attachment.document}`;
                    const downloadLink = document.createElement('a');
                    const fileName = attachment.fileName;
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                }
            }
        }
    }
    const oncloseClicked = () => {
        setIsAttachmentPreviewOpen(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'custom-table-container', children: _jsx("div", { className: 'vn-table-container', children: _jsx("div", { className: 'vn-main', children: _jsxs("table", { className: 'table align-middle', children: [_jsx("thead", { className: 'vn-table-thead', children: _jsxs("tr", { className: 'vn-custom-grid-header-card', children: [_jsx("th", {}), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Bestandsnaam" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Aangemaakt" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Bestandstype" }) })] }) }), _jsx("tbody", { className: 'vn-table-tbody', children: debtorAttachments &&
                                        debtorAttachments?.map((attachment) => (_jsxs("tr", { style: { cursor: 'pointer' }, onClick: () => {
                                                onRowClick(attachment.id);
                                            }, children: [_jsx("td", { children: _jsx(VnButton, { type: 'button', mode: 'danger', size: 'sm', customClassName: 'Vn-grid-delete-button', icon: trashOutline, onClick: (e) => {
                                                            e.stopPropagation();
                                                            if (handleRolePermission(Permission.KLANTEN, PermissionType.Update)) {
                                                                deleteDebtorAttachment(attachment.id);
                                                            }
                                                        } }) }), _jsx("td", { className: 'pt-4', children: _jsx("span", { children: attachment.fileName.substring(0, attachment.fileName.lastIndexOf('.')) }) }), _jsx("td", { className: 'pt-4', children: _jsx("span", { children: formatDMY(attachment?.created.toString()) }) }), _jsx("td", { className: 'pt-4', children: attachment.fileName && (_jsxs("span", { children: [attachment.fileName.toLowerCase().split('.').pop()?.toUpperCase(), " File"] })) })] }, attachment.id))) })] }) }) }) }), _jsx(VnConfirmationModel, { title: 'Wilt u deze bijlage verwijderen?', onCancel: () => onCancelDeleteClicked(), onConfirm: () => onDeleteClicked(), onOpen: isDeleteConformOpen }), _jsx(ModalPopup, { content: _jsx(AttachmentPreviewModal, { attachmentSrc: attachmentSrc, onClose: () => oncloseClicked() }), onOpen: isAttachmentPreviewOpen, onClose: () => oncloseClicked(), modalWidth: 'lg' })] }));
};
export default AttachmentsTable;
